export const quillConfig = {
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{list: 'ordered'}, {list: 'bullet'}],
      [{align: []}],
      ['link'],
      ['clean'],
    ],
  },
  formats: [
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'align',
    'link'
  ]
}